(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("popmotion"), require("stylefire"));
	else if(typeof define === 'function' && define.amd)
		define(["popmotion", "stylefire"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("popmotion"), require("stylefire")) : factory(root["popmotion"], root["stylefire"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__922__, __WEBPACK_EXTERNAL_MODULE__543__) {
return 